import React from 'react';
import useReveal from '../hooks/useReveal';

const steps = [
  {
    number: '01',
    title: 'Analisi & Assessment',
    description:
      "Prima di tutto, ascoltiamo. Conduciamo un'analisi approfondita della vostra infrastruttura esistente, identifichiamo le vulnerabilita\u0300, le lacune di sicurezza e le aree di miglioramento. Il risultato e\u0300 un quadro chiaro della situazione attuale e degli obiettivi da raggiungere."
  },
  {
    number: '02',
    title: 'Progettazione della Soluzione',
    description:
      "Ogni azienda e\u0300 diversa: non esistono soluzioni standard. Progettiamo architetture IT su misura, scegliendo le tecnologie dei nostri partner strategici che meglio si adattano alle vostre esigenze operative, al vostro budget e ai vostri obiettivi di crescita."
  },
  {
    number: '03',
    title: 'Implementazione & Integrazione',
    description:
      "Gestiamo l\u2019intera fase di deployment con procedure testate e documentate, minimizzando i tempi di fermo operativo. Integriamo i nuovi sistemi con quelli esistenti e formiamo il vostro personale per garantire un\u2019adozione immediata e consapevole."
  },
  {
    number: '04',
    title: 'Supporto Continuativo',
    description:
      "Il nostro lavoro non finisce con il go-live. Offriamo monitoraggio proattivo 24/7, aggiornamenti costanti, threat intelligence in tempo reale e un team dedicato pronto a intervenire. Siamo il vostro presidio tecnologico permanente."
  }
];

const Approach = () => {
  return (
    <section id="approach" className="approach-section">
      <div className="approach-inner">
        <h2 className="section-title">Come operiamo</h2>
        <p className="section-subtitle">
          Un metodo strutturato per garantire risultati concreti, riproducibili e misurabili a ogni progetto.
        </p>
        <div className="approach-grid">
          {steps.map((step, idx) => {
            const [ref, visible] = useReveal();
            return (
              <div
                key={idx}
                ref={ref}
                className={`approach-card reveal${visible ? ' reveal-visible' : ''}`}
                style={{ transitionDelay: `${idx * 0.12}s` }}
              >
                <span className="approach-number">{step.number}</span>
                <h3 className="approach-card-title">{step.title}</h3>
                <p className="approach-card-desc">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Approach;
